module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-devices"
  }, [_c('div', {
    staticClass: "panelheader border-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))]), _vm._v(" "), _c('div', {
    staticClass: "new-device-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": function($event) {
        _vm.openNewDeviceForm()
      }
    }
  }, [_vm._v("Add Device")])], 1)]), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('div', {
    staticClass: "devices"
  }, [(_vm.loading) ? _c('div', [_c('icon', {
    staticClass: "loading-icon",
    attrs: {
      "name": "circle-o-notch",
      "scale": "1.5",
      "spin": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    class: {
      noShow: _vm.loading
    },
    attrs: {
      "api-url": "/api/super/devices",
      "http-options": _vm.header,
      "fields": _vm.columns,
      "detail-row-component": "relay-table",
      "pagination-path": ""
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked,
      "vuetable:loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-actions"
        }, [_c('button', {
          staticClass: "ui icon button edit-btn",
          on: {
            "click": function($event) {
              _vm.updateDevice(props.rowData.id)
            }
          }
        }, [_c('i', {
          staticClass: "edit icon"
        })]), _vm._v(" "), _c('button', {
          staticClass: "ui icon button del-btn",
          on: {
            "click": function($event) {
              _vm.deleteDevice(props.rowData.id)
            }
          }
        }, [_c('i', {
          staticClass: "delete icon"
        })]), _vm._v(" "), _c('el-popover', {
          ref: "pingpopover",
          attrs: {
            "placement": "right",
            "trigger": "hover",
            "content": 'Ping: ' + props.rowData.ping,
            "disabled": !_vm.pingPop
          }
        }), _vm._v(" "), _c('div', {
          directives: [{
            name: "popover",
            rawName: "v-popover:pingpopover",
            arg: "pingpopover"
          }],
          staticClass: "ui icon button test-btn",
          class: {
            online: props.rowData.online
          },
          attrs: {
            "data-content": "Is online"
          },
          on: {
            "click": function($event) {
              _vm.testDevice(props.rowData)
            }
          }
        }, [_c('i', {
          staticClass: "idea icon"
        })])], 1)]
      }
    }])
  })], 1)]) : _vm._e(), _vm._v(" "), _c('new-device', {
    attrs: {
      "display": _vm.dialogVisible,
      "update": _vm.updating,
      "device_id": _vm.device_id
    },
    on: {
      "closeForm": _vm.closeForm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-412b7a8e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/Devices.vue
// module id = 1157
// module chunks = 12